import React, { Component } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state) => {
    return {
        lon: state.appReducer.lon,
        lat: state.appReducer.lat,
    };
};

const data = [
    { label: "緯度", prop: "lat" },
    { label: "経度", prop: "lon" },
];

class Locinfo extends Component {
    constructor(props) {
        super(props);
        window.startLocInfo();
    }

    render() {
        return (
            <div className="TopBtnSwS">
                <ul>
                    {data.map((el, index) => (
                        <li className="l-row" key={index}>
                            <label>{el.label + "："}</label>
                            <p>{this.props[el.prop] == undefined ? "0.0" : this.props[el.prop].toFixed(this.props[el.prop] === 0 ? 1 : 5)}</p>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default connect(mapStateToProps)(Locinfo);
